<template>
  <d2-container>
    <template slot="header">
    <div class="app-container calendar-list-container">
      <!-- <div class="filter-container">
        <el-input  size="small" @keyup.enter.native="handleFilter" style="width: 200px;margin-right: 10px;" class="filter-item" placeholder="姓名或账户" v-model="listQuery.name"> </el-input>
        <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">搜索</el-button>
        <el-button size="small" class="filter-item"  v-permission:function="['downloadListManager_btn_add']" style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">添加</el-button>
      </div> -->
    </div>
    </template>

    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">

      <el-table-column align="center" label="id" width="65">
      <template slot-scope="scope">
        <span>{{scope.row.id}}</span>
      </template>
    </el-table-column>

    <el-table-column width="350" align="center" label="文件备注">
      <template slot-scope="scope">
        <span>{{scope.row.remark}}</span>
      </template>
    </el-table-column>

        <el-table-column width="300" align="center" label="创建人">
      <template slot-scope="scope">
        <span>{{scope.row.createUser}}</span>
      </template>
    </el-table-column>
        <el-table-column  width="300" align="center" label="创建时间">
      <template slot-scope="scope">
        <span>{{scope.row.createTime}}</span>
      </template>
    </el-table-column>
        <el-table-column fixed="right" align="center" label="操作"  width="200"> <template slot-scope="scope">
        <el-button v-permission:function="['downloadListManager_btn_edit']" size="small" type="success" @click="handleUpdate(scope.row)">编辑
        </el-button>
        <el-button v-permission:function="['downloadListManager_btn_del']" size="small" type="danger" @click="handleDelete(scope.row)">删除
        </el-button>
        <el-button  size="small" type="danger" @click="donloadFile(scope.row.id)">下载
        </el-button>
      </template> </el-table-column>
    </el-table>
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
      </div>
    </template>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="" prop="filepath">
      <el-input v-model="form.filepath" placeholder="请输入"></el-input>
    </el-form-item>
        <el-form-item label="" prop="createUser">
      <el-input v-model="form.createUser" placeholder="请输入"></el-input>
    </el-form-item>
        <el-form-item label="" prop="createTime">
      <el-input v-model="form.createTime" placeholder="请输入"></el-input>
    </el-form-item>
        </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')"  size="small">取 消</el-button>
        <el-button v-if="dialogStatus=='create'"  size="small" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" size="small" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import axios from "axios";
import util from "@/libs/util";
import {  page,
      addObj,
      getObj,
      delObj,
      putObj } from "@/api/sysTool/downloadList/index";
  import { mapGetters } from 'vuex';
  export default {
    name: 'downloadList',
    data() {
      return {
        form: {
        filepath : undefined,        createUser : undefined,        createTime : undefined          },
        rules: {
    filepath: [
  {
    required: true,
    message: '请输入',
    trigger: 'blur'
  }
],   createUser: [
  {
    required: true,
    message: '请输入',
    trigger: 'blur'
  }
],   createTime: [
  {
    required: true,
    message: '请输入',
    trigger: 'blur'
  }
]        },
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 20,
          name: undefined
        },
        dialogFormVisible: false,
        dialogStatus: '',
        textMap: {
          update: '编辑',
          create: '创建'
        },
        tableKey: 0
      }
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters([
        'elements'
      ])
    },
    methods: {
      getList() {
        this.listLoading = true;
        page(this.listQuery).then(response => {
          this.list = response.rows;
          this.total = response.total;
          this.listLoading = false;
      })
      },
      donloadFile(id){
        const token = util.cookies.get('token');
        this.listLoading = true;
      axios({
          url: process.env.VUE_APP_API + '/api/ocr/downloadList/downloadFile/' + id,
          method: 'get',
          dataType: 'json',
          responseType: "arraybuffer",
          headers: {
            // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
            authorization: 'Bearer ' + token
          }
        }).then((res) => {

          const disposition = res.headers["content-disposition"];
          const fileName = decodeURI(disposition);
          let url = window.URL.createObjectURL(
            new Blob([res.data], { type: ".zip" })
          );
          let a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          a.setAttribute("download", fileName);
          document.body.appendChild(a);
          a.click();
          url = window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
          this.fileList = [];
          this.listLoading = false;
          this.$notify({
            title: "成功",
            message: res.message,
            type: "success",
            duration: 10000,
          });

        }).catch(res=>{
          this.listLoading = false;
          this.$notify({
            title: "文件已清理",
            message: res.message,
            type: "error",
            duration: 10000,
          });his
        })
      },
      handleFilter() {
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      handleCreate() {
        this.resetTemp();
        this.dialogStatus = 'create';
        this.dialogFormVisible = true;
      },
      handleUpdate(row) {
        getObj(row.id)
            .then(response => {
          this.form = response;
        this.dialogFormVisible = true;
        this.dialogStatus = 'update';
      });
      },
      handleDelete(row) {
        this.$confirm('此操作将永久删除, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
          delObj(row.id)
      .then(() => {
          this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        });
        const index = this.list.indexOf(row);
        this.list.splice(index, 1);
      });
      });
      },
      create(formName) {
        const set = this.$refs;
        set[formName].validate(valid => {
        if (valid) {
        addObj(this.form)
        .then(() => {
        this.dialogFormVisible = false;
        this.getList();
        this.$notify({
        title: '成功',
        message: '创建成功',
        type: 'success',
        duration: 2000
        });
        })
        } else {
        return false;
        }
        });
      },
      cancel(formName) {
        this.dialogFormVisible = false;
        const set = this.$refs;
        set[formName].resetFields();
      },
      update(formName) {
        const set = this.$refs;
        set[formName].validate(valid => {
        if (valid) {
        this.dialogFormVisible = false;
        this.form.password = undefined;
        putObj(this.form.id, this.form).then(() => {
        this.dialogFormVisible = false;
        this.getList();
        this.$notify({
        title: '成功',
        message: '创建成功',
        type: 'success',
        duration: 2000
        });
        });
        } else {
        return false;
        }
        });
      },
      resetTemp() {
        this.form = {
          username: undefined,
          name: undefined,
          sex: '男',
          password: undefined,
          description: undefined
        };
      }
    }
  }
</script>
